import Reveal from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";
import { useLinks } from "@/admin/SiteContent";

export const CtaBanner = () => {
  const lk = useLinks();
  return (
    <section className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl card-wow p-10 sm:p-14 lg:p-20">
            <div
              className="orb bg-[#D4AF37]"
              style={{ width: 460, height: 460, right: "-8%", top: "-30%", opacity: 0.25 }}
            />
            <div
              className="orb bg-[#00D4FF]"
              style={{ width: 320, height: 320, left: "-6%", bottom: "-30%", opacity: 0.16, animationDelay: "4s" }}
            />

            <div className="relative grid lg:grid-cols-2 gap-10 items-center">
              <div>
                <span className="font-mono-pl text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">
                  Accesso al server
                </span>
                <h3 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase text-[#F5F5F5] leading-[0.98] tracking-wide mt-5">
                  Pronto a entrare <br />
                  <span className="text-gold glow-gold">in città?</span>
                </h3>
                <p className="text-[#B6B6BE] mt-6 max-w-lg text-base leading-relaxed">
                  I passaggi pratici restano separati dalla lore: prima prepari
                  il client, poi entri in Discord e completi whitelist e
                  connessione.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row lg:justify-end gap-4">
                <a
                  href={lk.join}
                  className="btn-gold inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 text-sm font-bold uppercase tracking-wider"
                >
                  Connetti a FiveM
                  <ArrowUpRight size={18} strokeWidth={2.8} />
                </a>
                <a
                  href={lk.discord}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-ghost-neon inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 text-sm font-semibold"
                >
                  Apri Discord
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CtaBanner;
